import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=34d59f06&scoped=true"
import script from "./branding.vue?vue&type=script&lang=js"
export * from "./branding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d59f06",
  null
  
)

export default component.exports